/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	ColaborationHistoryDTO,
	ColaborationHistoryDTOFromJSON,
	ColaborationHistoryDTOFromJSONTyped,
	ColaborationHistoryDTOToJSON,
} from "./ColaborationHistoryDTO";

/**
 *
 * @export
 * @interface ColaborationHistoryDTOPagedResponse
 */
export interface ColaborationHistoryDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof ColaborationHistoryDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof ColaborationHistoryDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof ColaborationHistoryDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<ColaborationHistoryDTO>}
	 * @memberof ColaborationHistoryDTOPagedResponse
	 */
	data?: Array<ColaborationHistoryDTO> | null;
}

export function ColaborationHistoryDTOPagedResponseFromJSON(
	json: any
): ColaborationHistoryDTOPagedResponse {
	return ColaborationHistoryDTOPagedResponseFromJSONTyped(json, false);
}

export function ColaborationHistoryDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ColaborationHistoryDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(ColaborationHistoryDTOFromJSON),
	};
}

export function ColaborationHistoryDTOPagedResponseToJSON(
	value?: ColaborationHistoryDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(ColaborationHistoryDTOToJSON),
	};
}
